import { takeLatest, select } from 'redux-saga/effects';
import { chatModuleInstanceSelector } from '../selectors';
import chatConsts from '../constants';

function* loadNextHistoryPageWorker(action) {
  const chatModuleInstance = yield select(chatModuleInstanceSelector);
  const { channelId } = action.payload;
  const channel = chatModuleInstance.getCircle(channelId);

  channel && channel.loadNextHistoryPage(); // eslint-disable-line no-unused-expressions
}

export default function* loadNextHistoryPageSaga() {
  yield takeLatest(
    [chatConsts.LOAD_NEXT_HISTORY_PAGE],
    loadNextHistoryPageWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/loadNextHistoryPage.js